import { removeComponentProps } from '@hts/shared/utils';
import { CSSProperties, ComponentProps, forwardRef, memo, useMemo } from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/HtsLink.module.scss';
import { HtsTypography } from './HtsTypography';

interface IHtsLinkProps {
  isConditionalLink?: boolean;
  redirectTo: string;
  label: string;
  underline?: boolean;
  typographyProps?: ComponentProps<typeof HtsTypography>;
  linkProps?: Omit<ComponentProps<typeof Link>, 'to'>;
}

export const HtsLink = memo(
  forwardRef<HTMLAnchorElement, IHtsLinkProps>(
    ({ redirectTo, label, underline, typographyProps, linkProps, isConditionalLink }, ref) => {
      const newLinkProps = removeComponentProps(linkProps, ['className', 'style']);
      const color = typographyProps?.color || 'black';

      const style = useMemo<CSSProperties>(
        () => ({
          textDecoration: underline ? 'underline' : 'none',
          color,
          ...linkProps?.style,
        }),
        [color, linkProps?.style, underline]
      );

      if (isConditionalLink) {
        return <HtsTypography {...typographyProps}>{label}</HtsTypography>;
      }

      return (
        <Link
          to={redirectTo}
          ref={ref}
          className={`${styles.link} ${linkProps?.className || ''}`}
          style={style}
          {...newLinkProps}
        >
          <HtsTypography {...typographyProps}>{label}</HtsTypography>
        </Link>
      );
    }
  )
);
